module.exports = __webpack_public_path__ + "static/media/ios-radio-button-on.84d6f619.svg";